// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyCTAMrOlkRSPjgY0wmjAArqhUv5_XHSyrA",
    authDomain: "p-angular-cb7fc.firebaseapp.com",
    databaseURL: "https://p-angular-cb7fc.firebaseio.com",
    projectId: "p-angular-cb7fc",
    storageBucket: "p-angular-cb7fc.appspot.com",
    messagingSenderId: "538366323042",
    appId: "1:538366323042:web:c462a933e1a4bf9c74a43b",
    measurementId: "G-KCCEVVY02Q"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
